export default "__VITE_ASSET__Bzf2G$L1__"